import { Overrides } from '@material-ui/core/styles/overrides';

import { CORPORATE_COLORS } from '../colors/corporate';

export const selectOverrides: Overrides = {
  MuiSelect: {
    root: {
      "&[aria-expanded='true']": {
        borderRadius: '36px 36px 0px 0px'
      }
    },
    select: {
      '&:focus': {
        backgroundColor: 'none'
      }
    },
    selectMenu: {
      height: '54px'
    },
    outlined: {
      padding: '24px'
    },
    icon: {
      top: '20%',
      fill: CORPORATE_COLORS.PRIMARY,
      width: '36px',
      height: '36px',
      '@media (max-width:600px)': {
        top: '30%',
        width: '24px',
        height: '24px'
      }
    },
    iconOutlined: {
      right: '16px',
      '@media (max-width:600px)': {
        right: '12px'
      }
    }
  }
};
